import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { replaceArabicNumbers } from '../shared/helpers/ten-date-adapter';
import { LanguageService } from '../shared/services/language-service';

const DEFAULT_LOCALE = 'en-gb';

@Pipe({
  name: 'momentPipe',
  standalone: true,
})
export class MomentPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  public transform(date: Moment | Date | string, format: string): string {
    const locale = this.languageService.currentLanguage || DEFAULT_LOCALE;
    const currentFormat =
      locale === 'ar-ae' && format === 'L' ? 'DD/MM/y' : locale === 'ja-jp' && format === 'h:mm A' ? 'A h:mm' : format;
    const transformed = moment(date).parseZone().locale(locale).format(currentFormat);

    return locale === 'ar-ae' ? replaceArabicNumbers(transformed) : transformed;
  }
}
